import { render, staticRenderFns } from "./Header3.vue?vue&type=template&id=46d462af&scoped=true&"
import script from "./Header3.vue?vue&type=script&lang=js&"
export * from "./Header3.vue?vue&type=script&lang=js&"
import style0 from "./Header3.vue?vue&type=style&index=0&id=46d462af&prod&lang=scss&"
import style1 from "./Header3.vue?vue&type=style&index=1&id=46d462af&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d462af",
  null
  
)

export default component.exports